import { defineMessages } from "@/i18n";
import en from "./en";

export const framesFileMessages = defineMessages("frames-file", en);
